import React, { createContext, useState, useContext } from 'react';

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
    const [dynamicTitle, setDynamicTitle] = useState('');
    return (
        <BreadcrumbContext.Provider value={{ dynamicTitle, setDynamicTitle }}>
            {children}
        </BreadcrumbContext.Provider>
    );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
